<script setup lang="ts">
import { type VNode } from 'vue'
import { RouterLink, type RouterLinkProps } from 'vue-router'

import { Text, type TextProps } from '@/components'

import * as styles from './Link.css'

export interface LinkProps extends RouterLinkProps, TextProps {}

export interface LinkSlots {
  default(props: { isActive: boolean; isExactActive: boolean }): Array<VNode>
}

const { to, custom, replace, viewTransition, ...rest } = defineProps<LinkProps>()

defineSlots<LinkSlots>()

defineOptions({
  inheritAttrs: false
})
</script>

<template>
  <router-link
    v-slot="{ href, navigate, isActive, isExactActive }"
    v-bind="{ to, custom, replace }"
    custom
  >
    <Text v-bind="rest" as-child :class="styles.link">
      <a
        :aria-current="isExactActive ? 'page' : false"
        v-bind="$attrs"
        :href="href"
        @click="navigate"
      >
        <slot :is-active="isActive" :is-exact-active="isExactActive" />
      </a>
    </Text>
  </router-link>
</template>
